import { useCounter, useKey } from "rooks";
import { useState } from 'react';
import { isMobile } from './deviceUtils';

const useProtectScreen = () => {
  const { value: valueProtection, increment, decrement, reset } = useCounter(0);
  const [focusProtection, setFocusProtection] = useState(true);


  const badKeyPressed = () => {
    if (!isMobile()) {
      increment();
    }
  };

  const badKeyLifted = (e) => {
    decrement();
    if (valueProtection < 0) { reset(); }
    if(valueProtection >= 1){
      checkIfKeyCaptureError(e)
  }
  };

  const checkIfKeyCaptureError = (e) => {
    if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
      reset();
    } 
  };

  const checkSpecialKeys = (e) => {
    if (!isMobile()) {
      if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
        setFocusProtection(true);
      } else {
        setFocusProtection(false);
      }
    }
  };

  useKey(["Shift", "Control", "ControlLeft", "ControlRight", "Meta"], (event) => badKeyPressed(event), {
    eventTypes: ["keydown"],
  });
  
  useKey(["Shift", "Control", "ControlLeft", "ControlRight", "Meta"], (event) => badKeyLifted(event), {
    eventTypes: ["keyup"],
  });

  window.onblur = () => {
    if (!isMobile()) {
      setFocusProtection(false);
    }
  };

  window.onfocus = (e) => {
    checkSpecialKeys(e);
  };

  // return the counter value and whether to show protection or not
  return {valueProtection, focusProtection};
};

export default useProtectScreen;
